/**
 * Dashboard admin: viewSupplier query op alle /api/dashboard/* calls.
 */

export function withViewSupplier(pathOrUrl, viewSupplier) {
  const v = typeof viewSupplier === 'string' ? viewSupplier.trim() : '';
  if (!v) return pathOrUrl;
  const sep = pathOrUrl.includes('?') ? '&' : '?';
  return `${pathOrUrl}${sep}viewSupplier=${encodeURIComponent(v)}`;
}
